import React from 'react';
import { Link } from 'gatsby';
import cnames from 'classnames';

import GoX from 'react-icons/lib/go/x';
import GoThreeBars from 'react-icons/lib/go/three-bars';

import styles from './MobileNavBar.module.scss';

class MobileNavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
    this.setState({ menuOpen: !this.state.menuOpen });
  }

  render() {
    const { className, location } = this.props;
const items = [
      // { title: "Let Remi Speak", path: '/let-remi-speak/', highlight: true },
      { title: 'Program', path: '/program/' },
      { title: 'Speakers', path: '/speakers/' },
      { title: 'Tickets', path: '/tickets/' },
      { title: 'Info', path: '/info/' },
      { title: 'Highlights', path: '/highlights/' },
    ];

  return (
    <div className={cnames(className, styles.mobileNavBar)}>
      {location !== '/' && <Link to="/"><img className={styles.logo} src="/assets/logo.png" /></Link> }
      <button className={styles.menuButton} onClick={this.toggleMenu}>
  {this.state.menuOpen ? <GoX /> : <span>MENU <GoThreeBars /></span> }
      </button>
      <div className={cnames(styles.menu, { [styles.menuOpen]: this.state.menuOpen })}>
      <nav className={styles.links}>
        <ul>
          {items.map(item =>
            <li key={item.path}>
              <Link to={item.path}
                className={cnames(styles.link, { [styles.highlight]: item.highlight })}
                activeClassName={styles.active}
              >
                {item.title}
              </Link>
            </li>
          )}
        </ul>
      </nav>
      </div>
    </div>
    );
  }

}

export default MobileNavBar;